import { callEndpoint } from "src/api"
import { notNullFilter } from "../../features/dataFunctions/dataFunctions"
import { getItemWebStorage, setItemWebStorage } from "../../features/webStorageSaver"
import { setDatabaseOptions, setIdsOfPathsWithGeometry, setPathsList, setPathsListIsGroupedByRaions, setRoadRaionSegments, setRoadsList } from "../../stateManagement/reducers"
import { store } from "../../stateManagement/store"
import { objectsApiSlice } from "src/api/rtk/base/slices/objectsApiSlice"
import { pathsApiSlice } from "src/api/rtk/base/slices/pathsApiSlice"
import { tablesApiSlice } from "src/api/rtk/base/slices/tablesApiSlice"
import { helpApiSlice } from "src/api/rtk/base/slices/helpApiSlice"

export function configureDatabaseSelectOptions(databaseUrlPrefix: any) {
    const fullConfig = store.getState().config.fullConfig
    let databaseSelectOptions = Object.entries(fullConfig).map(([prefix, config]: any) => {
        const { selectable, company: name } = config
        if (selectable) {
            return { prefix, name }
        }
    }).filter(notNullFilter)
    if (databaseUrlPrefix) {
        const filteredDatabaseSelectOptions = databaseSelectOptions.filter((databaseOption: any) => databaseOption.prefix === databaseUrlPrefix)
        if (filteredDatabaseSelectOptions.length > 0) {
            databaseSelectOptions = filteredDatabaseSelectOptions
        }
    }
    databaseSelectOptions.sort((a, b) => a?.name.localeCompare(b?.name))
    store.dispatch(setDatabaseOptions(databaseSelectOptions))
}

export async function getRoads() {
    const data = await callEndpoint<{}, { value: any[] }>(
        pathsApiSlice.endpoints.getRoads,
        {},
        "Ошибка запроса списка дорог"
    );
    const roadsList = data?.value
    if (roadsList) {
        const light = roadsList.map(({ Name, Id }: any) => ({ Name, Id }))
        store.dispatch(setRoadsList(light))
        const localPathsInfo = getItemWebStorage('pathsInfo')
        const newPathsInfo = { ...localPathsInfo, roadsList: light }
        setItemWebStorage('pathsInfo', newPathsInfo)
    }
}

export async function getRoadRaionSegments() {
    const { pathsListCanBeGroupedByRaions } = getItemWebStorage('currentConfig') ?? {};
    if (pathsListCanBeGroupedByRaions) {
        const data = await callEndpoint<{}, { value: any[] }>(
            tablesApiSlice.endpoints.getTableValue,
            { tableValueUrl: "objects/RoadRaionSegments" },
            "Ошибка запроса районных сегментов"
        );
        const roadRaionSegments = data?.value
        if (roadRaionSegments) {
            const light = roadRaionSegments.map(({ PathID, RaionId, RaionName }: any) => ({ PathID, RaionId, RaionName }))
            store.dispatch(setRoadRaionSegments(light))
            store.dispatch(setPathsListIsGroupedByRaions(true))
            const localPathsInfo = getItemWebStorage('pathsInfo')
            const newPathsInfo = { ...localPathsInfo, roadRaionSegments: light, pathsListIsGroupedByRaions: true }
            setItemWebStorage('pathsInfo', newPathsInfo)
        }
    }
}

export async function getPaths() {
    const data = await callEndpoint<{}, { value: any[] }>(
        pathsApiSlice.endpoints.getPaths,
        {},
        "Ошибка запроса списка направлений"
    );
    const pathsList = data?.value
    if (pathsList) {
        const light = pathsList.map(({ Name, RoadName, PathID, RoadId }: any) => ({ Name, RoadName, PathID, RoadId }))
        store.dispatch(setPathsList(light))
        const localPathsInfo = getItemWebStorage('pathsInfo')
        const newPathsInfo = { ...localPathsInfo, pathsList: light }
        setItemWebStorage('pathsInfo', newPathsInfo)
    }
}

export async function getIdsOfPathsWithGeometry() {
    const idsOfPathsWithGeometry = await callEndpoint<{}, { value: any[] }>(
        pathsApiSlice.endpoints.getIdsOfPathsWithGeometry,
        {},
        "Ошибка запроса ID направлений, имеющих геометрию"
    );
    if (idsOfPathsWithGeometry) {
        store.dispatch(setIdsOfPathsWithGeometry(idsOfPathsWithGeometry))
        const localPathsInfo = getItemWebStorage('pathsInfo')
        const newPathsInfo = { ...localPathsInfo, idsOfPathsWithGeometry }
        setItemWebStorage('pathsInfo', newPathsInfo)
    }
}

// функция для запроса на получения списка всех типов объектов
export async function getObjectTypes(token: any) {
    const objectTypesStructure = await callEndpoint<{}, { value: any[] }>(
        objectsApiSlice.endpoints.getObjectTypesStructure,
        { token },
        "Ошибка запроса дерева объектов"
    );
    setItemWebStorage('objectTypesStructure', objectTypesStructure)
    const objectTypes = configureObjectTypesList(objectTypesStructure).filter(notNullFilter)
    setItemWebStorage('objectTypes', objectTypes)
}

// функция для запроса на получения списка всех типов объектов
export async function getAddressTypes() {
    const data = await callEndpoint<{}, { value: any[] }>(
        objectsApiSlice.endpoints.getAddressTypes,
        {},
        "Ошибка запроса адресных типов"
    );
    const addressTypes = data?.value
    addressTypes && setItemWebStorage('addressTypes', addressTypes);
}

// функция для запроса на получения списка всех типов объектов
export async function getIROSVersionBuild() {
    const data = await callEndpoint<{}, any>(
        helpApiSlice.endpoints.getApplicationInfo,
        {},
        'Не удалось запросить версию IRS, установите её самостоятельно в конфигурации.'
    );
    const irosVersionBuild = data?.VersionBuild
    if (irosVersionBuild) {
        const currentConfig = getItemWebStorage("currentConfig");
        const updatedCurrentConfig = {...currentConfig, irosVersionBuild}
        setItemWebStorage('currentConfig', updatedCurrentConfig)
    }
}

// функция для получения массива названий всех типов объектов
export function configureObjectTypesList(items: any) {
    if (!Array.isArray(items)) return [];
    let results: any = [];
    items.forEach((item: any) => {
        const { UrlUrl, url, Caption, CaptionSingular, ClassId, ImageIndex } = item ?? {}
        if (UrlUrl || url) {
            let name = UrlUrl ?? url.split('/')[1]
            let objectTypeParameters = {
                name,
                caption: Caption,
                captionSingular: CaptionSingular,
                classId: ClassId,
                imageIndex: ImageIndex,
                mapLayer: item.mapLayer,
                queryType: item.queryType
            }
            results.push(objectTypeParameters)
        }
        if (item.Types) {
            const childResults = configureObjectTypesList(item.Types);
            results = [...results, ...childResults];
        }
    });
    return results;
}